<!-- The Tutoring space: students and families, the calendar, tutors, and the packages you offer. -->
<script lang="ts">
  import { shows } from "../settings/index.ts";
  import * as TT from "../settings/tutoring.ts";
  import { router, type TutoringTab } from "../lib/router.svelte.ts";
  import { tutoring } from "../lib/tutoring.svelte.ts";
  import Students from "./tutoring/Students.svelte";
  import Tutors from "./tutoring/Tutors.svelte";
  import Packages from "./tutoring/Packages.svelte";
  import Calendar from "./tutoring/Calendar.svelte";
  import Mine from "./tutoring/Mine.svelte";
  import { nav } from "../lib/nav.svelte.ts";

  const tab = $derived<TutoringTab>(router.route.name === "tutoring" ? router.route.tab : "students");
  // Families and tutors get their own part of Tutoring (the server sends only theirs). Yours is
  // read fresh on every Tutoring page you open, like a group's pages.
  $effect(() => {
    void tab;
    if (!nav.asMember) void tutoring.load();
  });

  const TABS: [TutoringTab, string][] = [
    ["students", "Students"],
    ["calendar", "Calendar"],
    ["tutors", "Tutors"],
    ["packages", "Packages"],
  ];
  const TITLES: Record<TutoringTab, string> = {
    students: TT.TUTORING_LEDE_STUDENTS,
    calendar: TT.TUTORING_LEDE_CALENDAR,
    tutors: TT.TUTORING_LEDE_TUTORS,
    packages: TT.TUTORING_LEDE_PACKAGES,
  };
</script>

{#if nav.asMember}
  <Mine />
{:else}
<div class="page">
  <div class="page-head">
    <div>
      <h1>{TABS.find(([t]) => t === tab)?.[1] ?? "Tutoring"}</h1>
      {#if shows(TITLES[tab])}<p class="lede">{TITLES[tab]}</p>{/if}
    </div>
  </div>
  {#if tutoring.error}<p class="owes">{tutoring.error}</p>{/if}
  {#if !tutoring.loaded}
    <p class="muted">Getting tutoring from the server.</p>
  {:else if tab === "students"}<Students />
  {:else if tab === "calendar"}<Calendar />
  {:else if tab === "tutors"}<Tutors />
  {:else}<Packages />
  {/if}
</div>
{/if}
